<template>
  <div class="ocupancy-chart-container">
    <HotelOccupancyChart
      v-if="!isLoadingAllData"
      :dataOptions="dataOptions"
      :legends="legends"
      :dataSets="processedDataSets"
      :hasFilter="true"
      :chartType="'bar'"
      :chartId="'ocupancy-category-chart'"
      title="Ocupação Hoteleira Média Mensal"
      :selectedModes="selectedModesOccupancy"
      @filter-change="handleFilterChange"
    />
    <CustomSkeleton v-if="isLoadingAllData" type="card" />
  </div>
</template>

<script>
import HotelOccupancyChart from './HotelOccupancyChart.vue'
import CustomSkeleton from '@/Shared/CustomSkeleton.vue'
import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

export default {
  name: 'HotelOccupancy',
  components: {
    HotelOccupancyChart,
    CustomSkeleton,
  },
  props: {
    hotelOccupancy: {
      type: Array,
      required: true,
    },
    isLoadingAllData: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedModesOccupancy: [], // Iniciar como array vazio para mostrar todos os dados por padrão
      questionnaireData: [],
    }
  },
  computed: {
    dataOptions() {
      const categories = [...new Set(this.questionnaireData.map((answer) => answer.answer_text))]
      return categories.map((category) => {
        return { label: category, value: category }
      })
    },
    legends() {
      const categories = [...new Set(this.questionnaireData.map((answer) => answer.answer_text))]
      return categories.map((category) => {
        return {
          text: category,
          color: this.getCategoryColor(category),
        }
      })
    },
    processedDataSets() {
      const categories = [...new Set(this.questionnaireData.map((answer) => answer.answer_text))]
      return categories.map((category) => {
        return {
          label: category,
          value: category.toLowerCase(),
          toolTipLegend: 'Respostas',
          color: this.getCategoryColor(category),
          answers: this.questionnaireData.filter((answer) => answer.answer_text === category),
        }
      })
    },
  },
  watch: {
    hotelOccupancy: {
      immediate: true,
      handler(newVal) {
        this.questionnaireData = newVal
      },
    },
  },
  methods: {
    handleFilterChange(selectedModes) {
      this.selectedModesOccupancy = selectedModes
    },
    getCategoryColor(category) {
      const categoryColors = {
        Pousadas: '#BD516C',
        'Diária até R$ 99': '#62AD9B',
        'Diária R$ 601 ou acima': '#7749F8',
        'Diária R$ 501 a R$ 600': '#324DDD',
        'Diária R$ 401 a R$ 500': '#FFA500',
        'Diária R$ 301 a R$ 400': '#FFD700',
        'Diária R$ 201 a R$ 300': '#888888',
        'Diária R$ 100 a R$ 200': '#000000',
      }
      return categoryColors[category] || '#000000'
    },
  },
}
</script>

<style src="./styles.css"></style>
